import styled from '@emotion/styled'
import { ImgHTMLAttributes, useState, useEffect, useRef } from 'react'

const supportedBlurFormats = ['jpg', 'jpeg', 'png', 'webp']
const supportedBlurUrls = ['prismic.io']

const canApplyBlur = (url: string): boolean => {
  const isSupportedUrl = supportedBlurUrls.some((supportedUrl) => url.includes(supportedUrl))
  if (!isSupportedUrl) {
    return false
  }

  const pathname = url.split('?')[0] // cut off query string
  const fileExtension = pathname?.split('.').pop()?.toLowerCase()
  if (!fileExtension) {
    return false
  }

  return supportedBlurFormats.includes(fileExtension)
}

export const LazyImage = (props: ImgHTMLAttributes<HTMLImageElement>) => {
  const [isLoaded, setIsLoaded] = useState(false)
  const [previewSrc, setPreviewSrc] = useState<string | undefined>(undefined)
  const imgRef = useRef<HTMLImageElement>(null)

  useEffect(() => {
    if (!props.src) {
      return
    }

    if (!canApplyBlur(props.src)) {
      setIsLoaded(true)
      return
    }

    setPreviewSrc(`${props.src}&blur=50`)
    setIsLoaded(false)

    // The image might be loaded already because it was cached
    if (imgRef.current?.complete) {
      setIsLoaded(true)
    }
  }, [props.src])

  return (
    <>
      <img
        {...props}
        src={isLoaded ? props.src : previewSrc || props.src}
        // if we run into an error, it could be due to blurring. In that case, try the original
        onError={() => setIsLoaded(true)}
      />

      {!isLoaded && props.src &&
        <HiddenImage
          src={props.src}
          ref={imgRef}
          onLoad={() => setIsLoaded(true)}
        />
      }
    </>
  )
}

const HiddenImage = styled.img` 
  display: none;
`
